import React from 'react';
import css from './spinner.module.scss';

export default function Spinner() {
  return <div className={css.spinner} aria-busy='true' aria-label='Loading' />;
}
